import { useQueryClient } from '@tanstack/react-query'
import { QueryKeys } from '../../../key-registry'
import { fetchTransitOperation } from '../api/fetchTransitOperation'
import { cancelSubmissionV2 } from '../api/http'

function useCancelTransitOperation(transitOperationId: number | null) {
  const qc = useQueryClient()

  const cancelTransitOperation = async (reason: string) => {
    if (!transitOperationId) throw new Error('Missing transit operation id')
    await cancelSubmissionV2({ id: transitOperationId, reason })

    const updated = await fetchTransitOperation(transitOperationId)
    qc.setQueriesData(
      {
        queryKey: QueryKeys.transitOperation.detailById({ id: updated.id as number }),
      },
      (prev) => {
        if (!prev) return prev
        return { ...prev, ...updated }
      },
    )
    await qc.invalidateQueries({
      queryKey: QueryKeys.eventLog.all(transitOperationId),
    })

    return updated
  }

  return {
    cancelTransitOperation,
  }
}

export default useCancelTransitOperation
